import { CounterType, GeneralIconName } from '@om-fe/models';
import { BemMethod, createBem } from '@om-fe/utils';
import { GeneralIcon } from '@om-fe/widgets/dist/components/icon/general-icon';
import { withSelectionBetslipData, WithSelectionBetslipDataModel } from '@om-fe/widgets/dist/widgets/betslip/with-betslip-selection-data/with-betslip-selection-data';
import { FavoriteTournamentsMenu } from '@om-fe/widgets/dist/widgets/menus/favorite-tournaments-menu/favorite-tournaments-menu';
import { PopularLinksMenu } from '@om-fe/widgets/dist/widgets/menus/popular-links-menu/popular-links-menu';
import { SportsMenu } from '@om-fe/widgets/dist/widgets/menus/sports-menu/sports-menu';
import React, { useCallback, useEffect, useState } from 'react';
import { compose } from 'redux';
import Anchor from '@om-fe/core/components/anchor/anchor';
import SimpleSearchTrigger, { SimpleSearchTriggerPublicProps } from '@om-fe/core/components/search/simple-search-trigger';
import { I18nContextInterface } from '@om-fe/core/core/i18n/utils';
import withTranslation from '@om-fe/core/core/i18n/with-translation';
import { HistoryLocationState, OMFE_LIVE_CALENDAR_RELOAD_SPORT_STORAGE_KEY, RouteNames } from '@om-fe/core/core/routing/utils';
import { listenToMessage, ReceivedMessageType, sendMessage, SendMessageType } from '@om-fe/core/utils/parent-communication';
import getConfig, { LeftSideBarConfig, OMFE2ConfigModel } from '@om-fe/core/utils/config';
import { SportsMenuType, EventNavigationMenuSelectedDetails } from '@om-fe/core/components/sports-nav/sports-nav.constants';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import BottomDrawer from '@om-fe/core/components/bottom-drawer/bottom-drawer';
import { SiteLinks } from '@om-fe/core/components/site-links/site-links';
import HelpSupportLinksNDW from '../../components/help-support-links/help-support-links';
import HelpSupportLinksCore from '@om-fe/core/pages/theme1/parts/help-support-links';
import SettingsMenu from '@om-fe/core/pages/theme1/parts/settings-menu';
import { setVirtualStateExtraParams } from '@om-fe/core/core/routing/custom-routes/custom-routes.utils';
import { isBrowser, sessionStorage as safeSessionStorage } from '@om-fe/utils';
import { useEMRouting } from '@om-fe/core/core/routing/with-routing';
interface BetslipButtonStoreProps {
    readonly betslipSelectionCount: number;
}

type BetslipButtonPublicProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;

export type TopMenuPublicProps = SimpleSearchTriggerPublicProps;

type TopMenuProps = TopMenuPublicProps & I18nContextInterface & BetslipButtonStoreProps;

const bem: BemMethod = createBem({
    name: 'TopMenu',
});

const config: OMFE2ConfigModel = getConfig();

function TopMenuComponent (
    {
        removeShowModalSportsMenu,
        removeShowModalQuickLinks,
        defaultSearchMap,
        gettext,
        searchTabsHasMatchTab,
        searchTabsHasTournamentTab,
        searchPlaceholder,
        searchRouteName,
        betslipSelectionCount,
    }: TopMenuProps) {
    const { getFullPath } = useEMRouting();
    const [showSportsMenu, setShowSportsMenu] = useState(false);
    const [showQuickLinks, setShowQuickLinks] = useState(false);
    const leftSideBarConfig: LeftSideBarConfig | undefined = config.leftSideBar;
    const enabledHorseRacing: boolean = config?.enabledHorseRacing ?? false;
    const enabledGreyHound: boolean = config?.enabledGreyHound ?? false;
    const hasMatchOfTheDayPage: boolean = config?.hasMatchOfTheDayPage ?? false;
    const helpSupportLinks: boolean = leftSideBarConfig?.helpSupportLinks || false;
    const coreHelpSupportLinks: boolean = leftSideBarConfig?.coreHelpSupportLinks || false;
    const settingsMenu: boolean = leftSideBarConfig?.settingsMenu || false;
    const showPopularLinksDisciplineIcons: boolean = leftSideBarConfig?.popularLinksMenu?.showDisciplineIcons ?? true;
    const enabledBetSimulate: boolean = config.simulate?.enabled ?? false;
    const [selectedSportsMenuType, setSportsMenuType] = useState<SportsMenuType>(SportsMenuType.None);
    const [selectedSportId, setSelectedSportId] = useState<string | undefined>();
    const [selectedSportChild, setSelectedSportChild] = useState<string | undefined>(undefined);
    const liveCalendarHomeSportId: string | undefined = config.leftSideBar?.siteLinksConfig?.liveCalendarNavigatesToHomeSportId;
    const liveCalendarLocationState: HistoryLocationState | undefined = liveCalendarHomeSportId
        ? { omfeLiveCalendarSportId: liveCalendarHomeSportId }
        : undefined;

    const handleClickLiveCalendar = () => {
        if (!liveCalendarHomeSportId) {
            return;
        }

        safeSessionStorage.setItem(OMFE_LIVE_CALENDAR_RELOAD_SPORT_STORAGE_KEY, liveCalendarHomeSportId);
    };

    const getDistanceFromTop = useCallback((details: EventNavigationMenuSelectedDetails) => {
        if (isBrowser() && config.virtualState){
            let checkMenu: string = '';
            if (details.location) {
                checkMenu = `a[href*='/${details.sport}/'][href*='/${details.location}/']`;
            } else if (details.tournamentCategory) {
                checkMenu = `a[href*='/${details.sport}/'][href*='/${details.tournamentCategory}/']`;
            } else if (details.tournament) {
                checkMenu = `a[href$='/${details.tournament}`;
            }

            if (checkMenu) {
                const target: Element | null = document.querySelector(checkMenu);
                if (target) {
                    const rect: DOMRect = target.getBoundingClientRect();
                    setVirtualStateExtraParams({ focusMenuFromTop: rect.top });
                }
            }
        }
    }, []);

    const updateSelectedTopSportsDetails = useCallback((details: EventNavigationMenuSelectedDetails) => {
        const { sport, sportChild } = details;
        setSportsMenuType(SportsMenuType.TopSports);
        setVirtualStateExtraParams({
            selectedSportsMenuType: SportsMenuType.TopSports,
            selectedSportId: sport,
            selectedSportChild: sportChild,
        });
        setSelectedSportId(sport);
        setSelectedSportChild(sportChild);
        getDistanceFromTop(details);
    }, []);

    const updateSelectedAllSportsDetails = useCallback((details: EventNavigationMenuSelectedDetails) => {
        const { sport, sportChild } = details;
        setSportsMenuType(SportsMenuType.AllSports);
        setVirtualStateExtraParams({
            selectedSportsMenuType: SportsMenuType.AllSports,
            selectedSportId: sport,
            selectedSportChild: sportChild,
        });
        setSelectedSportId(sport);
        setSelectedSportChild(sportChild);
        getDistanceFromTop(details);
    }, []);

    const handleToggleSportsMenu = () => {
        setShowSportsMenu(!showSportsMenu);
    };

    const handleToggleQuickLinks = () => {
        setShowQuickLinks(!showQuickLinks);
    };

    const handleOpenBetslip = () => {
        sendMessage({ type: 'OP:showBetslip' as SendMessageType, isInternal: true });
    };

    useEffect(() => {
      if (typeof window !== 'undefined') {
            const searchParams = new window.URLSearchParams(window.location.search);
            if (searchParams.has('openSportsMenuModal')) {
                handleToggleSportsMenu();
            } else if (searchParams.has('openQuickLinksModal')) {
                handleToggleQuickLinks();
            }
        }
        removeShowModalSportsMenu = listenToMessage<void>(ReceivedMessageType.OpenSportsMenuModal, () => {
            handleToggleSportsMenu();
        });
        removeShowModalQuickLinks = listenToMessage<void>(ReceivedMessageType.OpenQuickLinksModal, () => {
            handleToggleQuickLinks();
        });
    }, [])

    useEffect(() => {
        return () => {
            if (removeShowModalSportsMenu) {
                removeShowModalSportsMenu();
            }
            if (removeShowModalQuickLinks) {
                removeShowModalQuickLinks();
            }
        }
    }, [removeShowModalSportsMenu, removeShowModalQuickLinks])

    const virtualSportRoute = getFullPath(RouteNames.newVirtualSports);

    return (
        <section className={bem()}>
            <SimpleSearchTrigger
                defaultSearchMap={defaultSearchMap}
                searchTabsHasMatchTab={searchTabsHasMatchTab}
                searchTabsHasTournamentTab={searchTabsHasTournamentTab}
                searchPlaceholder={searchPlaceholder}
                searchRouteName={searchRouteName}
            />
            <Anchor className={bem('MenuItem', 'LiveNow')} routeName={RouteNames.liveSports}>
                <GeneralIcon name="play-circle" />
                <span className={bem('MenuItemText')}>{gettext('live')}</span>
            </Anchor>
            <button className={bem('MenuItem', 'AllSports')} onClick={handleToggleSportsMenu}>
                <GeneralIcon name="view-list" />
                <span className={bem('MenuItemText')}>{gettext('Sports')}</span>
            </button>
            {hasMatchOfTheDayPage && (
                <Anchor className={bem('MenuItem', 'MatchOfTheDay')} routeName={RouteNames.MatchOfTheDay}>
                    <GeneralIcon name="match-of-the-day" />
                    <span className={bem('MenuItemText')}>
                        {gettext("Today's Match")}
                    </span>
                </Anchor>
            )}
            {liveCalendarHomeSportId && (
                <Anchor
                    className={bem('MenuItem', 'LiveCalendar')}
                    routeName={RouteNames.home}
                    locationState={liveCalendarLocationState}
                    handleClickAnchor={handleClickLiveCalendar}
                >
                    <GeneralIcon name={GeneralIconName.Calendar} />
                    <span className={bem('MenuItemText')}>{gettext('Live calendar')}</span>
                </Anchor>
            )}
            <button className={bem('MenuItem', 'QuickLinks')} onClick={handleToggleQuickLinks}>
                <GeneralIcon name="link" />
                <span className={bem('MenuItemText')}>{gettext('Links')}</span>
            </button>
            <div className={bem('MenuItem', 'Betslip')} onClick={handleOpenBetslip}>
                <GeneralIcon name="betslip" />
                <span className={bem('SelectionCount')}>{betslipSelectionCount}</span>
            </div>
            {showSportsMenu && (
                    <BottomDrawer
                        onClose={handleToggleSportsMenu}
                        title={gettext('Please select a sport')}
                    >
                         <SportsMenu
                            controlledSelection
                            sportRoute={false}
                            virtualSportRoute={virtualSportRoute}
                            selectedSport={selectedSportsMenuType === SportsMenuType.TopSports ? selectedSportId : ''}
                            selectedSportChild={selectedSportsMenuType === SportsMenuType.TopSports ? selectedSportChild : ''}
                            displayShortTournamentName={true}
                            widgetTitle={gettext('Top Sports')}
                            itemsLimit={999}
                            counterType={CounterType.numberOfEvents}
                            headerIconName={GeneralIconName.ViewList}
                            showTopSportsOnly={true}
                            hideTournament={true}
                            onSelectedDetailsChange={updateSelectedTopSportsDetails}
                            showMoreText={gettext('Show More')}
                            showLessIcon={'minus'}
                            showMoreIcon={'plus'}
                            supportTournamentNav={true}
                            enabledBetSimulate={enabledBetSimulate}
                        />
                        <SportsMenu
                            controlledSelection
                            sportRoute={false}
                            virtualSportRoute={virtualSportRoute}
                            selectedSport={selectedSportsMenuType === SportsMenuType.AllSports ? selectedSportId : ''}
                            selectedSportChild={selectedSportsMenuType === SportsMenuType.AllSports ? selectedSportChild : ''}
                            displayShortTournamentName={true}
                            widgetTitle={gettext('All Sports')}
                            itemsLimit={999}
                            counterType={CounterType.numberOfEvents}
                            headerIconName={GeneralIconName.ViewList}
                            hideTournament={true}
                            onSelectedDetailsChange={updateSelectedAllSportsDetails}
                            showMoreText={gettext('Show More')}
                            showLessIcon={'minus'}
                            showMoreIcon={'plus'}
                            excludeTopSports={true}
                            supportTournamentNav={true}
                            displayShowMoreButton={false}
                            enabledBetSimulate={enabledBetSimulate}
                        />
                    </BottomDrawer>
                )}

                {showQuickLinks && (
                    <BottomDrawer
                        onClose={handleToggleQuickLinks}
                    >
                        <SiteLinks
                            deviceType="mobile"
                            disableNextEvents={true}
                            disablePopularEvents={true}
                            handleClose={handleToggleQuickLinks}
                        />
                        <FavoriteTournamentsMenu
                            widgetTitle={gettext('Favorite Tournaments')}
                            headerIconName={GeneralIconName.Link}
                            showDisciplineIcons={true}
                            enabledHorseRacing={enabledHorseRacing}
                            enabledGreyHound={enabledGreyHound}
                        />
                        <PopularLinksMenu
                            widgetTitle={config.enabledTopMenu ? gettext('Popular') : gettext('Quick Links')}
                            headerIconName={GeneralIconName.Link}
                            showDisciplineIcons={showPopularLinksDisciplineIcons}
                        />
                        {helpSupportLinks && (coreHelpSupportLinks
                            ? <HelpSupportLinksCore />
                            : <HelpSupportLinksNDW />
                        )}
                        {!helpSupportLinks && settingsMenu &&
                            <SettingsMenu />
                        }
                    </BottomDrawer>
                )}
        </section>
    );
}

const TopMenu: React.ComponentType<TopMenuPublicProps> = compose<React.ComponentType<TopMenuPublicProps>>(
    withTranslation<TopMenuPublicProps>(),
    withSelectionBetslipData<BetslipButtonPublicProps>(),
    connect(
        (state: AppState, ownProps: WithSelectionBetslipDataModel): BetslipButtonStoreProps => {
            const selectionsLength: number = ownProps.selectionList.length;
            if (!selectionsLength) {
                return {
                    betslipSelectionCount: 0,
                };
            }

            return {
                betslipSelectionCount: selectionsLength,
            };
        },
    ),
)(TopMenuComponent);
export default TopMenu;
